import { cn } from '../../lib/utils';

/**
 * LocationBadge - Displays location with icon
 *
 * Used throughout the app to show pickup areas.
 */
export default function LocationBadge({
  location,
  size = 'md',
  variant = 'default',
  className,
}) {
  if (!location) return null;

  const sizeClasses = {
    sm: 'text-xs gap-1',
    md: 'text-sm gap-1.5',
    lg: 'text-base gap-2',
  };

  const iconSizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const variantClasses = {
    default: 'text-cream/60',
    muted: 'text-cream/40',
    primary: 'text-primary',
    badge: 'bg-primary/10 text-primary px-2 py-1 rounded-full',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
    >
      <LocationIcon className={iconSizeClasses[size]} />
      <span>{location}</span>
    </span>
  );
}

/**
 * LocationBadgeLink - Clickable location badge that opens maps
 */
export function LocationBadgeLink({ location, className, ...props }) {
  if (!location) return null;

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location + ', Ireland')}`;

  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-cream/60 hover:text-primary transition-colors',
        className
      )}
      {...props}
    >
      <LocationIcon className="w-4 h-4" />
      <span>{location}</span>
      <ExternalIcon className="w-3 h-3 opacity-50" />
    </a>
  );
}

// Icons
function LocationIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
}

function ExternalIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
    </svg>
  );
}
